import React from "react";
import moment from "moment-jalaali";
import { ToggleButton } from "primereact/togglebutton";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { SelectButton } from "primereact/selectbutton";
import Header from './Header.js'
import { connect } from "react-redux";
import Server from "./Server.js";

class TurnRating extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.toast = React.createRef();
    this.state = {
      Date: moment(),
      layout: "list",
      name: "",
      Type: "1",
      mobile: "",
      nationalCode: "",
      Settings: {},
      CodeFile: [],
      selectedDay: [],
      reservedDays: [],
      currentCounter: "",
      originalSelectedDay: [],
      selectedId: null,
      Time: "morning",
      CounterList: [],
      CounterListLength: 0,
      sendSms: true,
      mounth: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      key: [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "toelve",
      ],
      Mounth: {},
      siteName : this.Server.getSystem() ? this.Server.getSystem().name : ""
    };
  }
  componentDidMount() {
    this.getTurnRateSettings();
  }
  getTurnRateSettings = () => {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      year: moment(new Date()).local("fa").format("jYYYY"),
      activeInApp: true,
      systemId : this.props.systemId
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        Settings: response.data.result[0] || {error:1},
      });
      if (response.data.result[0] && response.data.result[0]._id)
        that.GetTurnRatesReserved(response.data.result[0]._id);
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/GetTUrnRateLists", param, SCallBack, ECallBack);
  };

  GetTurnRatesReserved = (_id) => {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      settingId: _id ? _id : this.state.Settings._id,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.GenerateReserveDetails(response.data.result[0]);
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send(
      "AdminApi/GetTurnRatesReserved",
      param,
      SCallBack,
      ECallBack
    );
  };

  GenerateReserveDetails = (response) => {
    let that = this;
    const reserved = response.reserved;
    const reservedDays = [];
    reserved.map((rrr) => {
      for (let day of rrr.selectedDay) {
        reservedDays.push(day);
      }
    });
    let Mounth = {
      one: [],
      two: [],
      three: [],
      four: [],
      five: [],
      six: [],
      seven: [],
      eight: [],
      nine: [],
      ten: [],
      eleven: [],
      toelve: [],
    };
    let week = [
      "یکشنبه",
      "دوشنبه",
      "سه شنبه",
      "چهارشنبه",
      "پنج شنبه",
      "جمعه",
      "شنبه",
    ];
    for (let item of response.records) {
      let index = parseInt(item.day.split("_")[1]) - 1;
      item.Mounth = that.state.mounth[index];
      item.MounthNum = parseInt(item.day.split("_")[1]);
      item.Day = item.day.split("_")[2];
      item.Year = item.day.split("_")[0];
      item.value = item.day;
      item.label = item.Day;
      if (item.MounthNum == 1) Mounth.one.push(item);
      if (item.MounthNum == 2) Mounth.two.push(item);
      if (item.MounthNum == 3) Mounth.three.push(item);
      if (item.MounthNum == 4) Mounth.four.push(item);
      if (item.MounthNum == 5) Mounth.five.push(item);
      if (item.MounthNum == 6) Mounth.six.push(item);
      if (item.MounthNum == 7) Mounth.seven.push(item);
      if (item.MounthNum == 8) Mounth.eight.push(item);
      if (item.MounthNum == 9) Mounth.nine.push(item);
      if (item.MounthNum == 10) Mounth.ten.push(item);
      if (item.MounthNum == 11) Mounth.eleven.push(item);
      if (item.MounthNum == 12) Mounth.toelve.push(item);
    }
    let showDiv = 0;
    if (Mounth.toelve.length > 0) showDiv = 11;
    if (Mounth.eleven.length > 0) showDiv = 10;
    if (Mounth.ten.length > 0) showDiv = 9;
    if (Mounth.nine.length > 0) showDiv = 8;
    if (Mounth.eight.length > 0) showDiv = 7;
    if (Mounth.seven.length > 0) showDiv = 6;
    if (Mounth.six.length > 0) showDiv = 5;
    if (Mounth.five.length > 0) showDiv = 4;
    if (Mounth.four.length > 0) showDiv = 3;
    if (Mounth.three.length > 0) showDiv = 2;
    if (Mounth.two.length > 0) showDiv = 1;
    if (Mounth.one.length > 0) showDiv = 0;
    that.setState({
      loading: 0,
      showDiv: showDiv,
      Mounth: Mounth,
      Allow: true,
      reservedDays: reservedDays,
    });
  };


  getDayTurns = (selectedDay) => {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      selectedDay: selectedDay,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      const usersList = that.state.Settings.usersList;
      const data = response.data.result.filter((item)=>{
        return item.Time == that.state.Time
      });
      const Counters = [];
      for (let uuu of usersList) {
        Counters.push({
          username : uuu.username,
          number: data.filter((item)=>{
            return uuu.username === item.Counter
          }).length
        })
      }
      let currentCounter = "";
      for(let i=0;i<Counters.length;i++){
        for(let j=0;j<Counters.length;j++){
          if(Counters[i].number < Counters[j].number)
            currentCounter = Counters[i].username;
        }
      }
      if(!currentCounter){
        currentCounter = usersList[0].username;
      }
      that.setState({
        loading: 0,
        currentCounter: currentCounter
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/getDayTurnRates", param, SCallBack, ECallBack);
  };
  
  SetEvent() {
    let that = this;
    let param = {
      mobile: this.state.mobile,
      name: this.state.name,
      nationalCode: this.state.nationalCode,
      settingId: this.state.Settings._id,
      selectedDay: this.state.selectedDay,
      Counter: this.state.currentCounter,
      Time: this.state.Time,
      _id: this.state.selectedId || null,
      siteName : this.state.siteName
    };
    if(this.state.selectedDay.length ==0){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "حداقل یک روز را انتخاب کنید",
        life: 3000,
      });
      return;
    }
    if(!this.state.Time){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "زمان نوبت را انتخاب کنید",
        life: 3000,
      });
      return;
    }
    if(!this.state.name){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "نام را وارد کنید",
        life: 3000,
      });
      return;
    }
    if(!this.state.mobile){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "موبایل را وارد کنید",
        life: 3000,
      });
      return;
    }
    if(!this.state.nationalCode){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "کد ملی را وارد کنید",
        life: 3000,
      });
      return;
    }
    this.setState({
      HasErrorForMaps: null,
      loading: 1,
    });
    let SCallBack = function (response) {
      if(response.data.error){
        that.toast.current.show({
          severity: "error",
          summary: "",
          detail: response.data.error,
          life: 3000,
        });
        that.setState({
          loading: false,
        });
      }else{
        that.toast.current.show({
          severity: "success",
          summary: "",
          detail: "عملیات با موفقیت انجام شد",
          life: 3000,
        });
        that.setState({
          loading: false,
          selectedDay: []
        });
        that.GetTurnRatesReserved();
      }
      
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
    };
    this.Server.send("AdminApi/setTurnRate", param, SCallBack, ECallBack);
  }
  render() {

    const TimeOptions = [];
    if(this.state.Settings.isMorning){
      TimeOptions.push(
        {
            value: "morning",
            label: "صبح",
        }
      )
    }
    if(this.state.Settings.isEvening){
      TimeOptions.push(
        {
            value: "evening",
            label: "عصر",
        }
      )
    }
    if(this.state.Settings.isNight){
      TimeOptions.push(
        {
            value: "night",
            label: "شب",
        }
      )
    };

    return (
        <div style={{height:'100%'}}>
         <Header  ComponentName="نوبت دهی اینترنتی" ComponentLName={this.props.ComponentLName} />
        <Toast
          ref={this.toast}
          position="top-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />
        {this.state.Settings.error ?
        <div style={{textAlign:'center',marginTop:150}}>
          <p>
            امکان دریافت نوبت اینترنتی در حال حاضر وجود ندارد
          </p>
        </div>
        :
        <div
          className="no-scroll-bar"
          style={{
            display: "inline",
            flexWrap: "wrap",
            overflow: "auto",
            direction: "rtl",
          }}
        >
        {this.state.Settings && this.state.Settings.desc &&
          <div style={{textAlign:'center',padding:5,fontWeight: "bolder",fontSize: "larger"}}>
          <p>
           {this.state.Settings.desc}
          </p>
        </div>
        }
         
          <div style={{textAlign:'center',padding:5}}>
          <p>
            برای دریافت نوبت اینترنتی ابتدا روز مورد نظر را انتخاب کنید و سپس نام و نام خانوادگی ، کد ملی و تلفن همراه خود را ثبت کنید
          </p>
        </div>
          {this.state.mounth.map((item, index) => {
            let key = this.state.key[index];
            let prev = index - 1;
            let next = index + 1;
            return (
              this.state.Mounth &&
              this.state.showDiv == index && (
                <div
                  style={{
                    border: "1px solid #eee",
                    textAlign: "center",
                    padding: 10,
                    position: "relative",
                    minHeight: 270,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                    }}
                  >
                    {index != 0 ? (
                      <div>
                        <i
                          className="fas fa-angle-double-right"
                          onClick={() => {
                            this.setState({
                              showDiv: prev,
                            });
                          }}
                        />
                      </div>
                    ) : (
                      <div>
                        <i />
                      </div>
                    )}
                    <div>
                      <p
                        className="iranyekanwebmedium"
                        style={{ textAlign: "center" }}
                      >
                        {this.state.mounth[index]}
                      </p>
                    </div>
                    {index != 11 ? (
                      <div>
                        <i
                          className="fas fa-angle-double-left"
                          onClick={() => {
                            this.setState({
                              showDiv: next,
                            });
                          }}
                        />
                      </div>
                    ) : (
                      <div>
                        <i />
                      </div>
                    )}
                  </div>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        maxWidth: 290,
                      }}
                    >
                      {this.state.Mounth[key] &&
                        this.state.Mounth[key].length > 0 &&
                        this.state.Mounth[key].map((item, index) => {
                          return (
                            <ToggleButton
                              style={{
                                width: 58,
                                direction: "rtl",
                                color:
                                  item.weekName == "5" || item.free && "red"
                              }}
                              checked={
                                this.state.selectedDay.indexOf(item.day) !== -1
                              }
                              disabled={
                                item.free ||
                                this.state.reservedDays.filter((iii) => {
                                  return iii == item.day;
                                }).length -
                                  this.state.originalSelectedDay.filter(
                                    (iii) => {
                                      return iii == item.day;
                                    }
                                  ).length >=
                                item.maxCapacity
                              }
                              offLabel={item.label}
                              onLabel={item.label}
                              onChange={(e) => {
                                item.checked = e.value;
                                let selectedDay = [];
                                if (e.value) selectedDay.push(item.day);
                                else {
                                  selectedDay.splice(
                                    selectedDay.indexOf(item.day),
                                    1
                                  );
                                }
                                this.setState({
                                  selectedDay: selectedDay,
                                });
                                this.getDayTurns(selectedDay);
                              }}
                            />
                          );
                        })}
                    </div>
                  </div>
                </div>
              )
            );
          })}
        </div>
        }
        {this.state.selectedDay.length > 0 &&
        
        <div style={{padding:20}}>
            <div className="p-float-label" style={{ textAlign: "right",marginTop:30 }}>
              <InputText
                autocomplete="off"
                style={{
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  textAlign: "center",
                }}
                type="text"
                id="name"
                tabIndex={1}
                value={this.state.name}
                name="name"
                onChange={(e) => this.setState({ name: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.passwordBtn.current.focus();
                  }
                }}
                required
              />
              <label
                className="iranyekanwebmedium "
                style={{ position: "absolute", right: 5 }}
              >
                نام و نام خانوادگی
              </label>
            </div>
            <div className="p-float-label" style={{ textAlign: "right",marginTop:30 }}>
              <InputText
                autocomplete="off"
                style={{
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  textAlign: "center",
                }}
                type="text"
                id="mobile"
                tabIndex={1}
                value={this.state.mobile}
                name="mobile"
                onChange={(e) => this.setState({ mobile: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.passwordBtn.current.focus();
                  }
                }}
                required
              />
              <label
                className="iranyekanwebmedium "
                style={{ position: "absolute", right: 5 }}
              >
               شماره موبایل
              </label>
            </div>
            <div className="p-float-label" style={{ textAlign: "right",marginTop:30 }}>
              <InputText
                autocomplete="off"
                style={{
                  fontFamily: "iranyekanwebmedium",
                  width: "100%",
                  textAlign: "center",
                }}
                type="text"
                id="nationalCode"
                tabIndex={1}
                value={this.state.nationalCode}
                name="nationalCode"
                onChange={(e) => this.setState({ nationalCode: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.passwordBtn.current.focus();
                  }
                }}
                required
              />
              <label
                className="iranyekanwebmedium "
                style={{ position: "absolute", right: 5 }}
              >
                کد ملی
              </label>
            </div>  
            <div style={{ textAlign: "right",marginTop:30 }}>
                <div>
                  <SelectButton
                    optionLabel="label"
                    optionValue="value"
                    value={this.state.Time}
                    options={TimeOptions}
                    onChange={(e) => {
                      this.setState({
                        Time: e.value,
                      },()=>{
                        this.getDayTurns(this.state.selectedDay);
                      });
                    }}
                    style={{border:0}}
                  ></SelectButton>
                </div>
              </div>
            <div
              style={{
                marginTop: 30,
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Button
                className="iranyekanwebmedium  p-button-lg p-button-primary"
                loading={this.state.ShowLoading}
                disabled={this.state.ShowLoading}
                tabIndex={3}
                ref={this.loginBtn}
                onClick={() => {
                  this.SetEvent();
                }}
                style={{
                  textAlign: "center",
                  borderRadius: 8,
                  padding: 8,
                  width: "50%",
                }}
              >
                <span className="iranyekanwebmedium" style={{ width: "100%",fontSize:16 }}>
                  ثبت نوبت
                </span>
              </Button>
            </div>
        
        </div>
        
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    systemId: state.systemId,

  };
}
export default connect(mapStateToProps)(TurnRating);
